module.exports = __webpack_public_path__ + "img/collection-engagementRingsSignature.e44c63c.jpg";